import { GlobovmsLogo } from "../brand/GlobovmsLogo";

const stats = [
  ["12", "Visitors on site"],
  ["6", "Expected today"],
  ["3", "Pending approvals"],
  ["28", "Checked in today"],
];

const rows = [
  ["John Visitor", "UPS", "Dana Okello", "Main Data Centre", "Expected", "09:10"],
  ["Amina Bekele", "Facilities Co", "James Kariuki", "Main Data Centre", "On site", "08:42"],
  ["David Chen", "Internal Audit", "Dana Okello", "DR Site", "Approved", "10:05"],
];

export function ProductShowcase() {
  return (
    <div className="relative mx-auto min-h-[440px] w-full max-w-xl">
      <div className="rounded-lg border border-slate-200 bg-white shadow-xl">
        <div className="flex items-center gap-2 border-b border-slate-100 px-4 py-2">
          <span className="h-2 w-2 rounded-full bg-slate-300" />
          <span className="h-2 w-2 rounded-full bg-slate-300" />
          <span className="h-2 w-2 rounded-full bg-slate-300" />
          <span className="ml-2"><GlobovmsLogo compact /></span>
        </div>
        <div className="grid sm:grid-cols-[128px_1fr]">
          <div className="hidden border-r border-slate-100 p-4 text-xs text-slate-500 sm:block">
            <p className="font-semibold text-brand-ink">Dashboard</p>
            <p className="mt-3">Visitors</p>
            <p className="mt-2">Approvals</p>
            <p className="mt-2">Sites</p>
          </div>
          <div className="p-4">
            <p className="text-sm font-bold">Dashboard</p>
            <div className="mt-3 grid grid-cols-2 gap-2 lg:grid-cols-4">
              {stats.map(([value, label]) => (
                <div key={label} className="rounded border border-slate-100 px-2 py-2">
                  <p className="text-xl font-bold text-brand-blue">{value}</p>
                  <p className="text-[11px] text-slate-500">{label}</p>
                </div>
              ))}
            </div>
            <p className="mt-4 text-xs font-bold">Recent visitors</p>
            <div className="mt-2 overflow-x-auto text-[11px]">
              <div className="grid min-w-[420px] grid-cols-6 gap-2 border-b border-slate-100 py-1 font-semibold text-slate-400">
                {["Name", "Company", "Host", "Site", "Status", "Time"].map((heading) => <span key={heading}>{heading}</span>)}
              </div>
              {rows.map((row) => (
                <div key={row[0]} className="grid min-w-[420px] grid-cols-6 gap-2 border-b border-slate-50 py-1 text-slate-600">
                  {row.map((cell) => <span key={cell}>{cell}</span>)}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="absolute -bottom-2 left-0 hidden w-[150px] rounded-[22px] bg-[#121820] p-1.5 shadow-xl sm:block">
        <div className="rounded-xl bg-white p-3">
          <GlobovmsLogo className="origin-left scale-75" />
          <p className="mt-3 text-sm font-bold">Welcome</p>
          <div className="mt-2 rounded bg-brand-orange px-2 py-2 text-center text-[10px] font-semibold text-white">Check In</div>
        </div>
      </div>
    </div>
  );
}
